// NotificationBell.jsx -- Sprint Hub S44
// Bell button: fetches unread count, polls every 60s, toggles NotificationPanel.
// Outside-click is handled HERE (ref wraps both button + panel) to avoid
// the toggle-reopen bug that occurs when outside-click lives in the panel.
// ASCII only. No Unicode.

import { useState, useEffect, useRef } from 'react';
import { getNotificationCount, markAllNotificationsRead } from '../lib/api.js';
import NotificationPanel from './NotificationPanel.jsx';

export default function NotificationBell(props) {
  var _count = useState(0);
  var count = _count[0]; var setCount = _count[1];
  var _open = useState(false);
  var open = _open[0]; var setOpen = _open[1];
  var wrapRef = useRef(null);

  function fetchCount() {
    getNotificationCount()
      .then(function(res) { if (res && res.data) setCount(res.data.unread || 0); })
      .catch(function() {});
  }

  // Fetch on mount, then poll every 60s
  useEffect(function() {
    fetchCount();
    var iv = setInterval(fetchCount, 60000);
    return function() { clearInterval(iv); };
  }, []);

  // Outside-click: close panel when click lands outside the wrapper div
  useEffect(function() {
    function onMouseDown(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onMouseDown);
    return function() { document.removeEventListener('mousedown', onMouseDown); };
  }, []);

  // Escape key: close panel
  useEffect(function() {
    function onKey(e) { if (e.key === 'Escape') setOpen(false); }
    document.addEventListener('keydown', onKey);
    return function() { document.removeEventListener('keydown', onKey); };
  }, []);

  function handleToggle() { setOpen(function(o) { return !o; }); }

  function handleClose() {
    setOpen(false);
    // Re-fetch so badge reflects any reads that happened in the panel
    fetchCount();
  }

  function handleMarkAllRead() {
    markAllNotificationsRead()
      .then(function() { setCount(0); setOpen(false); })
      .catch(function() {});
  }

  // Called by panel when a single notification is marked read
  function handleReadOne() {
    setCount(function(c) { return Math.max(0, c - 1); });
  }

  return (
    <div ref={wrapRef} data-testid="notification-bell" style={{ position: 'relative' }}>
      <button
        onClick={handleToggle}
        style={{
          background: 'none', border: 'none', cursor: 'pointer', padding: 0,
          width: 30, height: 30, borderRadius: 8,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          position: 'relative', color: 'inherit'
        }}
        aria-label="Notifications"
        aria-haspopup="true"
        aria-expanded={open}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
          <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
        </svg>
        {count > 0 && (
          <span style={{
            position: 'absolute', top: 0, right: 0, width: 16, height: 16,
            borderRadius: 8, background: '#EF4444', color: '#fff', fontSize: 9,
            fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>{count > 9 ? '9+' : count}</span>
        )}
      </button>
      {open && (
        <NotificationPanel
          onClose={handleClose}
          onMarkAllRead={handleMarkAllRead}
          onReadOne={handleReadOne}
        />
      )}
    </div>
  );
}
